"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowedFilesError = void 0;
exports.checkAttachments = checkAttachments;
exports.normalizeAttachments = normalizeAttachments;
exports.prepareAttachments = prepareAttachments;
exports.prepareAttachmentsForState = prepareAttachmentsForState;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var allowedFileTypes = ['zip', 'pdf', 'xml', 'txt', 'csv', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'jpg', 'jpeg', 'gif', 'png', 'webp', '8bf', 'abf', 'abr', 'act', 'aep', 'afm', 'ai', 'arw', 'as', 'ase', 'avi', 'bmp', 'book', 'cel', 'cfc', 'chproj', 'cptx', 'cr2', 'cr3', 'crf', 'crw', 'css', 'dn', 'dng', 'eps', 'epub', 'exif', 'fbx', 'fla', 'flac', 'flv', 'fm', 'heic', 'icma', 'icml', 'ico', 'ics', 'idml', 'indd', 'jsfl', 'json', 'log', 'loss', 'lrcat', 'lrtemplate', 'm4a', 'mif', 'mov', 'mp3', 'mp4', 'mpg', 'mpeg', 'nef', 'nrw', 'obj', 'odt', 'olf', 'orf', 'otc', 'otf', 'pfb', 'pfm', 'pmd', 'ppj', 'prc', 'prel', 'prproj', 'ps', 'psap', 'psb', 'psd', 'raf', 'raw', 'rtf', 'sbs', 'sbsar', 'sbsm', 'scc', 'ses', 'sesx', 'skp', 'sol', 'srt', 'srw', 'ssa', 'stl', 'svg', 'swf', 'tif', 'tiff', 'ttc', 'ttf', 'wav', 'wmv', 'x3f', 'xd', 'xmp', 'cpd', 'gz', 'tar.gz', 'har', 'odp', 'ods', 'pps', 'rar', 'rm', 'xlr', 'z', '7z', 'ioc', 'hex', 'c', 'cc', 'cpp', 'h', 'hpp', 'tar', 'xz', 'dts', 's'];
var allowedFilesError = {
  allowed_files_type: allowedFileTypes.join(', '),
  allowed_files_size: '5 Mb'
};
exports.allowedFilesError = allowedFilesError;

function normalizeAttachments(attachments) {
  attachments.forEach(function (attachment) {
    if ('file_original_name' in attachment && attachment.file_original_name === '') {
      attachment.file_original_name = attachment.source;
      attachment.filename = attachment.source;
    }
  });
  return attachments;
}

function checkAttachments(hasFileInProgress) {
  if (hasFileInProgress) {
    throw {
      response: {
        data: {
          errors: {
            pagetext: (0, _translations.t)('Common', 'file.upload.in.progress')
          }
        }
      }
    };
  }
}

function prepareAttachments(attachments) {
  return attachments.map(function (attachment) {
    if (attachment.type === 'image') {
      var _split$pop, _split$pop2;

      return {
        source: 'source' in attachment ? attachment.source : '',
        source_thumb: 'source_thumb' in attachment ? attachment.source_thumb : '',
        short_url: (_split$pop = ('source' in attachment ? attachment.source : '').split('/').pop()) !== null && _split$pop !== void 0 ? _split$pop : '',
        short_thumb_url: (_split$pop2 = ('source_thumb' in attachment ? attachment.source_thumb : '').split('/').pop()) !== null && _split$pop2 !== void 0 ? _split$pop2 : '',
        type: attachment.type,
        id: attachment.id
      };
    }

    return {
      filename: attachment.filename,
      type: attachment.type,
      source: 'source' in attachment ? attachment.source : '',
      source_thumb: 'source_thumb' in attachment ? attachment.source_thumb : '',
      file_uuid: 'file_uuid' in attachment ? attachment.file_uuid : '',
      file_size: 'file_size' in attachment ? attachment.file_size : 0,
      file_original_name: 'file_original_name' in attachment ? attachment.file_original_name : '',
      id: attachment.id
    };
  });
}

function prepareAttachmentsForState(attachments) {
  return attachments.map(function (attachment) {
    return _objectSpread(_objectSpread({}, attachment), {}, {
      url: 'short_url' in attachment ? attachment.short_url : attachment.source,
      filename: 'file_original_name' in attachment ? attachment.file_original_name : ''
    });
  });
}